"use client";

import React, { createContext, useContext, useState, useEffect } from "react";
import { getTranslations, getLangFromLocale, type Translations } from "@/utils/translations";

interface LocaleContextValue {
  locale: string;
  lang: string;
  t: Translations;
}

const LocaleContext = createContext<LocaleContextValue>({
  locale: "es-AR",
  lang: "es",
  t: getTranslations("es"),
});

export function useLocale() {
  return useContext(LocaleContext);
}

export function LocaleProvider({ defaultLocale, children }: { defaultLocale?: string; children: React.ReactNode }) {
  const [locale, setLocale] = useState(defaultLocale || "es-AR");

  useEffect(() => {
    if (defaultLocale) {
      setLocale(defaultLocale);
    } else {
      setLocale(navigator.language);
    }
  }, [defaultLocale]);

  const lang = getLangFromLocale(locale);
  const t = getTranslations(locale);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LocaleContext.Provider value={{ locale, lang, t }}>
      {children}
    </LocaleContext.Provider>
  );
}
